<div class="flex flex-grow flex-column">
    <div class="mv-xs">
        <h3>Ten SKU jest obecnie SKU głównym.</h3>
        <div class="mv-xs">
            <p class="mb-xxs">Usuń wszystkie SKU załeżne przed odznaczeniem tego SKU jako głównego.</p>
            <a class="text-button" (click)="unsetAsMain()">Odznacz "Główny"</a>
        </div>
    </div>
    <div class="flex flex-grow">
        <pr-new-local-table
            panel-body
            class="flex flex-grow"
            [tableData]="tableData"
            [columnsData]="columnsData"
            [tableId]="tableId"
            [canNavigate]="false"
            [isLoading]="isLoadingResults"
            [extraHeaderFieldTmpl]="extraHeader"
        >
            <ng-template #extraHeader>
                <div fxLayout="row"  fxLayoutAlign="flex-start center" class="">
                    <mat-icon (click)="toogleEdition()" class="text-primary" style="cursor: pointer;">edit</mat-icon>
                </div>
            </ng-template>
        </pr-new-local-table>
    </div>
</div>
